module.exports = __webpack_public_path__ + "img/logo-luxtag-powerby.aa6c7aca.png";